import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '@shared/lib/cn';

export function Checkbox({
  checked,
  onCheckedChange,
  className,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
}): JSX.Element {
  return (
    <CheckboxPrimitive.Root
      checked={checked}
      onCheckedChange={(value) => onCheckedChange(value === true)}
      className={cn(
        'inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-[4px] border transition-colors duration-fast',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600/20 focus-visible:ring-offset-2 focus-visible:ring-offset-paper',
        checked
          ? 'border-primary-700 bg-primary-700 text-white'
          : 'border-hairline-strong bg-elevated text-transparent',
        className,
      )}
    >
      <CheckboxPrimitive.Indicator forceMount>
        <Check className={cn('h-3.5 w-3.5 transition-opacity duration-fast', checked ? 'opacity-100' : 'opacity-0')} strokeWidth={2.25} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
